import axios from './axiosInterceptors';

const API_URL = "/api/v1/";

const getPages = () => {
    return axios.get(API_URL + `privilege-manager/pages`)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            console.log("AXIOS ERROR: ", err);
        })
};
const getPrivByRoleId = (role) => {
    
    return axios.post(API_URL + `privilege-manager/getrolepriv`, role)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            console.log("AXIOS ERROR: ", err);
        })
};
const updatePrivs = (privArr) => {
    return axios.post(API_URL + `privilege-manager/SetPrivs`, privArr)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            console.log("AXIOS ERROR: ", err);
        })
}


const allActions = {
    getPages,
    getPrivByRoleId,
    updatePrivs
};

export default allActions;